// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__0zD-Y","element":"Dropdown_element__imCrp","icon":"Dropdown_icon__QMgj7","flaggedIcon":"Dropdown_flaggedIcon__DC2ki"};